module.exports = __webpack_public_path__ + "static/img/image@1x.606906c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/image@1x.png
// module id = iNDh
// module chunks = 0